import React, { createContext, useState, useContext, useEffect } from "react";
import { useTranslation } from 'react-i18next';

const TitleContext = createContext({
  title: '',
  setTitle: () => {}
});

export const TitleProvider = ({ children }) => {
  const { t, i18n } = useTranslation('global');

  
  const [titleKey, setTitleKey] = useState('sidenav.home');
  const [title, setTitle] = useState(t(titleKey));

  
  useEffect(() => {
    const newTitle = t(titleKey);
    setTitle(newTitle);
    document.title = newTitle;
  }, [titleKey, i18n.language, t]);

  
  return (
    <TitleContext.Provider value={{ title, setTitle: setTitleKey }}>
      {children}
    </TitleContext.Provider>
  );
};

export const useTitle = () => {
  const context = useContext(TitleContext);
  if (context === undefined) {
    throw new Error('useTitle must be used within a TitleProvider');
  }
  return context;
};
